(function (window, $, nn) {

  nn.handlers.init.Saml = function () {
    nn.helpers.saml = new nn.component.Saml();
  };

})(window, jQuery, nn);